export const SOLR_DICTIONARY_DEFAULTS = {
  "407f7ec57e6047dabfce9517884307a6": "Clearing courses only",
  "638bdcde37914b5ab9a70f1f52ac9d4e": "Foundation Year courses only",
  "5a77704461a946329bb528abeec0b4ad":
    "Only show courses available to international (non EU) students",
};
